import React, { ChangeEvent, FormEvent, useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardMedia from '@material-ui/core/CardMedia';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';

import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import TextField from '@material-ui/core/TextField';
import CallIcon from '@material-ui/icons/Call';
import { useAppState } from '../../state';
import { MouseEvent } from 'react';
import useVideoContext from '../../hooks/useVideoContext/useVideoContext';

const useStyles = makeStyles({
  root: {
    maxWidth: 345,
    margin: 'auto',
  },
  media: {
    height: 140,
  },
  button: {
    width: '100%',
  },
});

export default function AdminActionCard() {
  const classes = useStyles();
  const { profile, getToken, sendSMS, isFetching } = useAppState();
  const [roomName, setRoomName] = useState<string>('');
  const [name, setName] = useState<string>(profile?.displayName || '');
  const { isConnecting, connect } = useVideoContext();

  const handleNameChange = (event: ChangeEvent<HTMLInputElement>) => {
    setName(event.target.value);
  };

  const handlePhoneChange = (event: ChangeEvent<HTMLInputElement>) => {
    setRoomName(event.target.value);
  };

  const handleCallSMS = (event: MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
    var phone = roomName.split(' ').join('');
    sendSMS(phone).then(token => console.log(token));
    // If this app is deployed as a twilio function, don't change the URL because routing isn't supported.

    if (!window.location.origin.includes('twil.io')) {
      window.history.replaceState(null, '', window.encodeURI(`/room/${phone}${window.location.search || ''}`));
    }
    getToken(name, phone).then(token => connect(token));

    // setRoomName(event.target.value);
  };

  return (
    <Card className={classes.root} elevation={3}>
      <CardActionArea>
        <CardMedia className={classes.media} image="/ContactTracer.png" title="Contact" />
        <CardContent>
          <Typography variant="h6">Please provide your name and Workers phone number</Typography>
          <form className={classes.root} noValidate autoComplete="off">
            <div>
              <TextField id="standard-name" label="Name" onChange={handleNameChange} value={name} />
              <TextField id="standard-phone" label="Phone No" onChange={handlePhoneChange} />
            </div>
          </form>
        </CardContent>
      </CardActionArea>
      <CardActions>
        <Button
          variant="contained"
          color="primary"
          size="large"
          className={classes.button}
          startIcon={<CallIcon />}
          onClick={handleCallSMS}
        >
          Send SMS and join the call
        </Button>
      </CardActions>
    </Card>
  );
}
